jQuery(document).ready(function($) {
    $('.openform-button').click(function(e){
        e.preventDefault();
        $('html,body').animate({ scrollTop: 0 }, 300);
        $('.bookingform-wrapper').slideDown();
    })

    $('#closeform').click(function(e){
        e.preventDefault();
        $('.bookingform-wrapper').hide();
    });
});